import { useEffect, useState } from "react";
import domain from "../../../../reusecomponent/domain";
import { ErrorToastContainer, SuccessToastContainer, WorningToastContainer } from "../../../function/CustomFunction";
import { getToken } from "../../../function/token";
import Preloader from "../../preloader";
import { faTasks } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function GooglesheetManage() {
  const [googlesheet, setGooglesheet] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();



  useEffect(()=>{
    GetGoogleSheet();
  },[]);

  let GetGoogleSheet = async () =>{
    if(googlesheet !== null){
      return;
    }
      try {
        setLoading(true);
        const access_token = getToken();
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${access_token}`);
        const response = await fetch(`${domain()}/marketplace/googlesheet/manage`, {
          method: 'GET',
          headers: myHeaders
        });
  
        const data = await response.json();
        if (data.status) {
          setGooglesheet(data.data);
        } else {
          WorningToastContainer(data.message);
        }
      } catch (error) {
        setLoading(false);
        ErrorToastContainer('Error fetching templates');
      }finally{
          setLoading(false);
      }
  }

  return(
      <div className="container-fluid dashboard-main pt-0" style={{height: "100vh"}}>
            <Preloader action={loading}/>
          <div className="card">
              <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                  <h4 className="card-title mb-4">
                    <FontAwesomeIcon icon={faTasks} className="me-2" />
                    Manage Google Sheet Configration
                </h4>
                <button className="btn btn-sm btn-primary me-2"
                          onClick={() => {
                            navigate("/client-area/whatsapp/marketplace/googlesheet/create");
                          }}
                        >
                        Create Google Sheet Configration
                </button>
              </div>
              {googlesheet && googlesheet.data.length > 0 ? (
                googlesheet.data.map((item) => (
                  <div className="card mb-3 shadow-sm" key={item.id}>
                    <div className="card-body d-flex justify-content-between align-items-center">
                      
                      <div>
                        <h6 className="mb-1">{item.sheet_name}</h6>
                        <small className="text-muted">
                          Created at: {new Date(item.created_at).toLocaleString() ?? 'N/A'}
                        </small>
                      </div>

                      <TogelButton id={item.id} Status={item.status}/>

                      <div>
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => {
                            navigate(`/client-area/whatsapp/marketplace/googlesheet/manage/${btoa(item.id)}`);
                          }}
                        >
                          Edit
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          // onClick={() => handleDelete(item.id)}
                        >
                          Delete
                        </button>
                      </div>

                    </div>
                  </div>
                ))
              ) : (
                !loading && <p className="text-center text-muted">No Google Sheets Found</p>
              )}


              </div>
          </div>
      </div>
  );
}
export default GooglesheetManage;



function TogelButton({ id, Status }) {
  const [status, setStatus] = useState(Number(Status) ? true : false);
  const [loading, setLoading] = useState(false);

  const handleChange = async (e) => {
    const newStatus = e.target.checked ? 1 : 0;
      try {
        setLoading(true);
        const access_token = getToken();
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${access_token}`);
        const response = await fetch(`${domain()}/marketplace/googlesheet/${btoa(id)}`, {
          method: 'PUT',
          headers: myHeaders
        });
  
        const data = await response.json();
        if (data.status) {
            setStatus(newStatus);
            SuccessToastContainer(data.message);
        } else {
          WorningToastContainer(data.message);
        }
      } catch (error) {
        setLoading(false);
        ErrorToastContainer('Error fetching templates');
      }finally{
        setLoading(false);
      }
 
  };

  return (
    <div>
      <Preloader action={loading}/>
      <h6 className="mb-1">Status</h6>
      <div className="form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          id={`userSwitch-${id}`}
          checked={status}
          onChange={handleChange}
        />

        <label
          className="form-check-label"
          htmlFor={`userSwitch-${id}`}
          style={{ cursor: "pointer" }}
        >
        </label>
      </div>
    </div>
  );
}

